import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useAuth } from "../../Context/AuthProvider";
import { url } from "../../Constant";
import { checkIndividualPermission } from "../../Utils/PermissionFunctions";
import { useParams } from "react-router-dom";
import { Cost } from "@carbon/icons-react";

const CampaginUpload = () => {
  const { auth } = useAuth();
  const params = useParams();
  const [errorEnable, setErrorEnable] = useState(false);
  const [loader, setLoader] = useState(false);
  const [previousAudiosList, setpreviousAudiosListList] = useState(null);
  const [fileUploadError, setFileUploadError] = useState("");
  const [selectedFormat, setSelectedFormat] = useState("");
  const [submittedData, setSubmittedData] = useState({
    userfile: "",
    vpbx_id: auth.vpbx_id,
    campagin_id: "",
    perviousAudio: "",
  });
  useEffect(() => {
    getPreviousPrompt();
    setSubmittedData({
      ...submittedData,
      campagin_id: params.campagin_id,
    });
  }, []);

  const getPreviousPrompt = () => {
    axios
      .post(
        url + "tcs-get-pervious-prompt",
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setpreviousAudiosListList([]);
            } else if (response.data.message === "Data Found") {
              setpreviousAudiosListList(response.data.data);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const handleFile = (e) => {
    setSelectedFormat("file");
    var file = e.target.files[0];
    var fileName = e.target.files[0].name;
    let fileNameSplit = fileName.split(".");
    let fileExtensionName = fileNameSplit[1];
    if (fileExtensionName !== "wav") {
      setFileUploadError("Please upload wav format file");
      setSubmittedData({
        ...submittedData,
        userfile: "Invalid File",
      });
    } else {
      setFileUploadError("");
      setSubmittedData({
        ...submittedData,
        userfile: file,
      });
    }
  };
  const uploadCampagin = () => {
    setErrorEnable(true);
    setLoader(true);
    var formData = new FormData();

    if (selectedFormat === "file") {
      formData.append("vpbx_id", submittedData.vpbx_id);
      formData.append("campaign_prompt", submittedData.userfile);
      formData.append("campaign_id", submittedData.campagin_id);
    } else {
      formData.append("vpbx_id", submittedData.vpbx_id);
      formData.append("campaign_prompt", submittedData.userfile);
      formData.append("campaign_id", submittedData.campagin_id);
      formData.append("perviousAudio", submittedData.perviousAudio);
    }

    if (
      (selectedFormat === "file" &&
        fileUploadError === "" &&
        submittedData.userfile !== "") ||
      (selectedFormat === "select" && submittedData.perviousAudio !== "")
    ) {
      axios
        .post(url + "/tcs-upload-campaign-prompt", formData, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.status === 200) {
              if (response.data.message === "Prompt Uploaded Successfully") {
                setLoader(false);
                toast.success(response.data.message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setTimeout(() => {
                  window.location.href = "/call-initialize";
                }, 2000);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  return (
    <div className="dashboardWrp" style={{ height: "100vh" }}>
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <h3>Campagin Upload</h3>
              </div>
            </div>
          </div>

          <form action="javascript:void(0);">
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <label>
                    <b>Upload Campagin</b>
                  </label>
                  {/* <span className="fileDisc">
                    Only .wav ﬁles.900kb max ﬁle size.
                  </span> */}
                  <div className="uk-margin-bottom">
                    <div uk-form-custom="target: true">
                      <input
                        type="file"
                        aria-label="Custom controls"
                        accept=".wav"
                        disabled={selectedFormat === "select" ? true : false}
                        onChange={(e) => handleFile(e)}
                      />
                      <input
                        className="uk-input uk-form-width-medium"
                        type="text"
                        placeholder="Choose files"
                        aria-label="Custom controls"
                        disabled
                      />
                      {/* {errorEnable && submittedData.userfile === "" && (
                        <div className="formErrors" style={{ color: "red" }}>
                          Please upload file
                        </div>
                      )} */}
                      {errorEnable && fileUploadError !== "" && (
                        <div className="formErrors" style={{ color: "red" }}>
                          {fileUploadError}
                        </div>
                      )}
                    </div>
                    {/* <button className="uk-button fileUploadBtn uk-button-default">Submit</button> */}
                  </div>
                  {/* <a
                    href={
                      "https://cap.zong.com.pk:8444/vpbx-apis/usr_sounds/default.zip"
                    }
                    className="DownloadFileBtn"
                  >
                    Download sample file
                  </a> */}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Call forwards type</label>
                  <select
                    className="uk-select"
                    aria-label="Select"
                    disabled={selectedFormat === "file" ? true : false}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        perviousAudio: e.target.value,
                      });
                      if (e.target.value == "") {
                        setSelectedFormat("");
                      } else {
                        setSelectedFormat("select");
                      }
                    }}
                  >
                    <option value="" selected>
                      Select previous extensions
                    </option>
                    {previousAudiosList?.map((val) => {
                      return <option value={val}>{val}</option>;
                    })}
                  </select>
                  {errorEnable && selectedFormat === "" && (
                    <div className="formErrors" style={{ color: "red" }}>
                      Please upload file or select from previous audios
                    </div>
                  )}
                </div>
                <div className="uk-width-1-1@m uk-float-right">
                  <div className="formActionBtn uk-text-right">
                    {/* <button className="whiteBtn">Cancel</button> */}
                    <button
                      className="pinkBtn"
                      onClick={() => uploadCampagin()}
                    >
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Adding
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CampaginUpload;
